import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-testid="auth-loading">
                <span className="text-brand-sageDark font-serif text-xl italic">Chargement…</span>
            </div>
        );
    }
    if (!user || !user.email) {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
}
